import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { LocationService } from '../../services/location.service';
import { DialogLocationsComponent } from './dialog-locations.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "../../services/location.service";
import * as i3 from "../../../../core/authentication/authentication.service";
import * as i4 from "../../../../../@fuse/components/progress-bar/progress-bar.service";
var DialogLocationService = /** @class */ (function () {
    function DialogLocationService(matDialog, locationService, authenticationService, fuseProgressBarService) {
        this.matDialog = matDialog;
        this.locationService = locationService;
        this.authenticationService = authenticationService;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    DialogLocationService.prototype.open = function (_a) {
        var locationId = _a.locationId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getLocation({ locationId: locationId })];
                    case 1:
                        location = _b.sent();
                        return [2 /*return*/, this.matDialog.open(DialogLocationsComponent, {
                                panelClass: ['dialog-locations'],
                                autoFocus: false,
                                data: {
                                    location: location,
                                    isViewMode: !this.authenticationService.hasPermission('locations-edit'),
                                }
                            }).afterClosed()
                                .toPromise()];
                }
            });
        });
    };
    DialogLocationService.prototype.getLocation = function (_a) {
        var locationId = _a.locationId;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        if (!locationId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.locationService.getLocationById(locationId)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = null;
                        _c.label = 3;
                    case 3:
                        result = _b;
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DialogLocationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogLocationService_Factory() { return new DialogLocationService(i0.ɵɵinject(i1.MatDialog), i0.ɵɵinject(i2.LocationService), i0.ɵɵinject(i3.AuthenticationService), i0.ɵɵinject(i4.FuseProgressBarService)); }, token: DialogLocationService, providedIn: "root" });
    return DialogLocationService;
}());
export { DialogLocationService };
